import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import Consultant, { OtherDocumentsByType as DocumentsByType } from "../../models/Consultant";
import { certificationTypes, otherDocumentTypes } from "../../utils/document.utils";
import DocumentCheckList from "./DocumentCheckList";

const RecruitmentDocumentCheckList: React.FC<{ candidate: Consultant }> = ({ candidate }) => {
	const { t } = useTranslation();

	const [certificationsByType, setCertificationsByType] = useState<DocumentsByType>({});
	const [otherDocumentsByType, setOtherDocumentsByType] = useState<DocumentsByType>({});

	useEffect(() => {
		if (candidate) {
			const cByType: DocumentsByType = {};

			certificationTypes.forEach((key) => {
				cByType[key] = {
					include: candidate.profile?.documents?.certificationsByType?.[key]?.include ?? false,
				};
			});

			setCertificationsByType(cByType);

			const oByType: DocumentsByType = {};

			otherDocumentTypes.forEach((key) => {
				oByType[key] = {
					include: candidate.profile?.documents?.otherDocumentsByType?.[key]?.include ?? false,
				};
			});

			setOtherDocumentsByType(oByType);
		}
	}, [candidate]);

	return (
		<ListWrapper>
			<ListInnerWrapper>
				<DocumentCheckList heading={t("CERTIFICATIONS")} documentsByType={certificationsByType} />
			</ListInnerWrapper>
			<DocumentCheckList heading={t("OTHER_DOCUMENTS")} documentsByType={otherDocumentsByType} />
		</ListWrapper>
	);
};

export default RecruitmentDocumentCheckList;

const ListWrapper = styled.div`
	margin: 50px 0;
	display: flex;
`;

const ListInnerWrapper = styled.div`
	margin-right: 130px;
`;
